export default __webpack_public_path__ + "static/media/icon-finish-options.4cf067c9.svg";